document.addEventListener('DOMContentLoaded', function() {
  
  // --- DESKTOP : GESTION DU DÉLAI ET DU SURVOL ---
  const triggers = document.querySelectorAll('.mega-menu-trigger');
  
  triggers.forEach(trigger => {
    let timeout;
    const container = trigger.querySelector('.mega-menu-container');
    
    if(!container) return;

    // Fonction pour ouvrir
    const openMenu = () => {
      clearTimeout(timeout);
      container.style.display = 'block';
      // Force le reflow pour l'animation
      void container.offsetWidth;
      container.style.opacity = '1';
      container.style.visibility = 'visible';
      container.style.transform = 'translateY(0)';
    };

    // Fonction pour fermer
    const closeMenu = () => {
      timeout = setTimeout(() => {
        container.style.opacity = '0';
        container.style.visibility = 'hidden';
        
        // Attendre la fin de l'animation CSS avant display:none
        setTimeout(() => {
          if (container.style.opacity === '0') {
             container.style.display = 'none';
          }
        }, 300); 
      }, 150); // Petit délai de tolérance
    };

    trigger.addEventListener('mouseenter', openMenu);
    trigger.addEventListener('mouseleave', closeMenu);
    trigger.addEventListener('focusin', openMenu);
    trigger.addEventListener('focusout', closeMenu);
  });

  // --- MOBILE : ACCORDÉON ---
  // On cible les détails dans le tiroir (drawer)
  const mobileDetails = document.querySelectorAll('.menu-drawer__menu details');
  
  mobileDetails.forEach(detail => {
    // Écouteur pour fermer les autres accordéons si on veut un comportement exclusif (optionnel)
    // Ici on laisse le comportement par défaut de Sense (multiple open allowed)
    
    detail.addEventListener('toggle', () => {
      if (detail.open) {
        // Correction Lazy Loading : Forcer le chargement des images
        const images = detail.querySelectorAll('img[loading="lazy"]');
        images.forEach(img => img.removeAttribute('loading'));
      }
    });
  });
});



